const API_BASE = process.env.NEXT_PUBLIC_BACKEND_URL?.trim();

/**
 * Construct a safe image URL for both dev and production
 */
export function getImageUrl(path: string): string {
  if (!path) return "/placeholder.webp";

  // Ensure path always has a leading slash
  const rel = path.startsWith("/") ? path : `/${path}`;

  if (!API_BASE) {
    console.warn("NEXT_PUBLIC_BACKEND_URL not set. Falling back to relative path:", rel);
    return rel; // fallback (only works if Next.js actually serves /uploads)
  }

  return `${API_BASE.replace(/\/$/, "")}${rel}`;
}
